/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import './withholding_config_request_response';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "dashboard": {
            "nested": {
              "withholding_config": {
                "nested": {
                  "DashboardWebWithholdingConfigService": {
                    "methods": {
                      "CreateWithholdingConfig": {
                        "requestType": ".squareup.bbfrontend.dashboard.withholding_config.CreateWithholdingConfigRequest",
                        "responseType": ".squareup.bbfrontend.dashboard.withholding_config.CreateWithholdingConfigResponse"
                      },
                      "ListWithholdingConfigs": {
                        "requestType": ".squareup.bbfrontend.dashboard.withholding_config.ListWithholdingConfigsRequest",
                        "responseType": ".squareup.bbfrontend.dashboard.withholding_config.ListWithholdingConfigsResponse"
                      },
                      "UpdateWithholdingConfig": {
                        "requestType": ".squareup.bbfrontend.dashboard.withholding_config.UpdateWithholdingConfigRequest",
                        "responseType": ".squareup.bbfrontend.dashboard.withholding_config.UpdateWithholdingConfigResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.withholding_config?.nested?.DashboardWebWithholdingConfigService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DashboardWebWithholdingConfigService @ squareup/bbfrontend/dashboardweb/withholding_config/withholding_config_service.proto at 12:1
 */
export const DashboardWebWithholdingConfigService = $root.lookupService('squareup.bbfrontend.dashboard.withholding_config.DashboardWebWithholdingConfigService');